import classNames from 'classnames/bind';

import { CheckIcon } from '@autopass-web/mochi-icons';

import styles from './mochi-radio.module.sass';

const cx = classNames.bind(styles);

interface MochiRadioProps {
  id?: string;
  name?: string;
  className?: string;
  isChecked: boolean;
  label?: string;
  onClick?: () => void;
  ariaLabel?: string;
  style?: React.CSSProperties;
}

export const MochiRadio = ({
  name,
  isChecked,
  label,
  onClick,
  ariaLabel,
  style,
  className,
}: MochiRadioProps) => {
  const radioClass = cx({
    'mochi-radio': true,
    'mochi-radio__checked': isChecked,
    'mochi-radio__empty-state': !isChecked,
  });

  return (
    <label
      id={name}
      style={style}
      className={cx({ 'mochi-radio-label': true }, className)}
      onClick={onClick}
    >
      <span
        className={radioClass}
        data-checked={isChecked}
        aria-checked={isChecked}
        aria-label={ariaLabel}
      >
        <input
          name={name}
          type="radio"
          aria-hidden
          hidden
          checked={isChecked}
          readOnly
          onClick={(e) => e.stopPropagation()}
        />
        {isChecked && <CheckIcon color="white" width={16} height={16} />}
      </span>
      {label}
    </label>
  );
};
